var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader",class:{ 'preloader_hidden' : !_vm.$preloader.show}},[_c('img',{attrs:{"src":require("@/assets/img/global/preloader.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }